import TitleBg from "../../images/pricing/titlebg.svg";
import MainButton from "../MainButton";

function Hero() {
  return (
    <>
      <section
        id="home"
        className="hero-section w-full h-screen min800:flex min800:justify-center min800:text-center"
      >
        <div className="container-hero">
          {/* hero section */}
          <div
            className="flex flex-col text-white
           absolute hero-text min800:items-center min800:-right-[22rem] min620:-right-[20rem] min800:w-[80%] min540:-right-[17rem] min450:-right-[14rem] min375:-right-[11rem]"
          >
            <p className="text-black text-[16px] uppercase font-medium relative z-10 pl-16 min800:pl-0 mb-8">
            Power Up, Crush!
            </p>
            <img
              src={TitleBg}
              alt="text_bg"
              className=" w-[52%] absolute -top-3 title-white min800:w-[24rem] "
            />
            <h1 className="font-bold text-[30px] uppercase mb-[4rem] min450:text-[40px]">
            Empower Your Journey  <br />
              <span className="font-thin">with Cutting-Edge Gear</span>
            </h1>
            

            <MainButton
              color={"text-black"}
              bg={"bg-white"}
              text="Contact us"
              goTo="/Contact"
            />
          </div>
        </div>
        {/* socials */}
        <div
          className="flex flex-row-reverse -rotate-90 text-white
          absolute top-2/4 right-0 items-center min800:hidden"
        >
          <p className="uppercase  text-3xl font-bold tracking-widest">share</p>
          <span className="w-[35px] bg-[#FF0336] h-[2.5px] mr-6"></span>
          <div className="text-white gap-7 flex mr-7">
  <a href="https://www.facebook.com/p/HI-FI-Fitness-100064087483090/" target="_blank" rel="noopener noreferrer">
    <i className="fa-brands rotate-90 hover:text-[#1877F2] fa-facebook text-3xl cursor-pointer ease-in duration-200"></i>
  </a>
  <a href="https://wa.me/+918056171722?text=Hi, I would like to join HIFI fitness" target="_blank" rel="noopener noreferrer">
    <i className="fa-brands rotate-90 hover:text-[#25D366] fa-whatsapp text-3xl cursor-pointer ease-in duration-200"></i>
</a>
<a href="https://www.instagram.com/hifi_fitness_parrys/?hl=en" target="_blank" rel="noopener noreferrer">
    <i className="fa-brands rotate-90 hover:text-[#C13584] fa-instagram text-3xl cursor-pointer ease-in duration-200"></i>
</a>

</div>

        </div>
      </section>
    </>
  );
}

export default Hero;